import { MerchJarSegmentsAPI } from '../../pages/recipe_detail'
import { Toasts } from '../toaster/Toast'

export const setSegmentEnabled = (recipe: Models.Recipe, enabled: boolean, onSaved: () => void) =>
    MerchJarSegmentsAPI.Segments.Edit(recipe.id ?? 0, { ...recipe, enabled })
        .then(() => {
            Toasts.success(enabled ? 'Segment enabled' : 'Segment disabled')
            onSaved()
        })
        .catch(() => {
            // The API wrapper already toasted the server message.
        })
